import { About } from './pages/About/About';
import { Admin } from './pages/Admin/Admin';
import { Calendar } from './pages/Calendar/Calendar';
import { CommunityDirectory } from './pages/CommunityDirectory/CommunityDirectory';
import { SubmitListing } from './pages/CommunityDirectory/SubmitListing';
import { Contact } from './pages/Contact/Contact';
import { Home } from './pages/Home/Home';
import { NotFound } from './pages/NotFound/NotFound';

export const routes = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/calendar',
    element: <Calendar />,
  },
  {
    path: '/community-directory',
    element: <CommunityDirectory />,
  },
  {
    path: '/community-directory/submit',
    element: <SubmitListing />,
  },
  {
    path: '/admin',
    element: <Admin />,
  },
  {
    path: '/404',
    element: <NotFound />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export const routeMap = routes.map((route) => route.path !== '*' && route.path);

export const staticRoutes = routes
  .map((route) => route.path)
  .filter((path): path is string => path !== '*');
